import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-controlpanel',
  templateUrl: './controlpanel.component.html',
  styles: []
})
export class ControlPanelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    
  }

}